import { useCallback, useState } from 'react';

export const useBool = (defaultValue) => {
    const [value, setValue] = useState(defaultValue);

    const onSet = useCallback((newValue) => {
        setValue(() => newValue);
    }, []);

    const onTrue = useCallback(() => {
        setValue(() => true);
    }, []);

    const onFalse = useCallback(() => {
        setValue(() => false);
    }, []);

    const onToggle = useCallback(() => {
        setValue((p) => !p);
    }, []);

    return {
        value,
        onSet,
        onTrue,
        onFalse,
        onToggle,
    };
};
